import { RequestApi } from '_helpers';
import {
  AccountDetails,
  UpdateUserProfileRequest,
  UserPayload,
} from '_types/User';

const getUserAccount = (email: string) => {
  return RequestApi.get<UserPayload>(`/users/getUserAccount/${email}`);
};

const createUser = async (userData: FormData) => {
  const response = await RequestApi.post('/users/createAccount', userData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const updateUserAccount = async (profile: UpdateUserProfileRequest) => {
  const response = await RequestApi.patch<AccountDetails>(
    '/users/profile',
    profile,
  );
  return response;
};

const syncUserAccount = async () => {
  const response = await RequestApi.get('/users/syncUserAccount');
  return response;
};

const deleteAccount = async () => {
  const response = await RequestApi.delete('/users/account');
  return response;
};

const getBookedSkatingSessions = async () => {
  const response = await RequestApi.get('/users/getBookedSkatingSessions');
  return response;
};

const getBookedSkatingLessons = async () => {
  const response = await RequestApi.get('/users/getBookedSkatingLessons');
  return response;
};

const getBookedHockeyLessons = async () => {
  const response = await RequestApi.get('/users/getBookedHockeyLessons');
  return response;
};

const getBookedSkatingPasses = async (sessionDate?: string) => {
  const query = sessionDate
    ? `?sessionDate=${encodeURIComponent(sessionDate)}`
    : '';
  const response = await RequestApi.get(
    `/users/getBookedSkatingPasses${query}`,
  );
  return response;
};

const getBookedParties = async () => {
  const response = await RequestApi.get('/users/getBookedParties');
  return response;
};

const getCustomerWaivers = async () => {
  const response = await RequestApi.get('/users/getCustomerWaivers');
  return response;
};

const userService = {
  getUserAccount,
  createUser,
  updateUserAccount,
  syncUserAccount,
  deleteAccount,
  getBookedHockeyLessons,
  getBookedSkatingLessons,
  getBookedSkatingSessions,
  getBookedSkatingPasses,
  getBookedParties,
  getCustomerWaivers,
};

export default userService;
